var widgetList = [];
jQuery(document).ready(function(){
	jQuery(".ic-blocks-map-avis").each(function(){
		let currentMap = jQuery(this);
		let mapSlider = new Slider(currentMap.find('.avis-container'));
		let mapSvg = currentMap.find('.map-container');
		let indexRegion = [];
		currentMap.find('.post-item').each(function(index, item){
			let currentPost = jQuery(item);
			if(currentPost.data('region') && !indexRegion[currentPost.data('region')] && indexRegion[currentPost.data('region')]!==0) indexRegion[currentPost.data('region')] = index;
		});
		Object.entries(indexRegion).forEach(entry => {
			const [region, postIndex] = entry;
			mapSvg.find('#'+region).click(function(){
				mapSvg.find('.region-area').each(function (index, item) {
					item.style.fill = "";
				});
				this.style.fill = "#212642";
				mapSlider.getSlider().slideTo(postIndex);
			})
		});
		widgetList = [
			...widgetList,
			{
				mapContainer : currentMap,
				sliderContainer : mapSlider
			}
		]
	})
})

function checkMapSlider(){
	widgetList.map((item)=>{
		if(item.mapContainer.hasClass('no-map')){
			item.sliderContainer.numberDesk = 3;
			item.sliderContainer.destroySlider();
			item.sliderContainer.createSlider();
		}else{
			item.sliderContainer.numberDesk = 1;
			item.sliderContainer.destroySlider();
			item.sliderContainer.createSlider();
		}
	})
}
window.checkMapSlider = checkMapSlider;
